<template>
    <div class="container rutube-carusel">
        <h2>Как прошла конференция</h2>
        <RutubePlayer :videoId="videoId"></RutubePlayer>

        <!-- <template v-if="video.lenght > 0"> -->
            <div class="__control">
                <ul
                    @wheel.prevent="handleScrollThumb"
                >
                    <li v-for="(item,index) in video" :key="index">
                        <button 
                            @click="() => handleClickThumb(item,index)"
                            :class="{ '__active': currentIndex === index }"
                        ><img :src="item.thumb">
                        </button>
                    </li>
                </ul>
            </div>
        <!-- </template> -->

    </div>
</template>
<script>
import RutubePlayer from './RutubePlayer.vue'
export default {
    name: 'VideoBlock',
    components: { RutubePlayer },
    props: {},
    data() {
        return {
            videoId: '2d0b9fdb821769b27c6f22976ddaff4b',
            currentIndex: 0,
            wheelLastPosition: 0,
            video: [
                {
                    videoId: '2d0b9fdb821769b27c6f22976ddaff4b',
                    thumb: '/assets/thumb/4fee719360e841c50b29d6f44bf3a941.jpg',
                },
                {
                    videoId: 'c1348b0997329be856857acf66a01e6c',
                    thumb: '/assets/thumb/83994c97437d5c1f3c4cc7864017462d.jpg',
                },
                {
                    videoId: '4b03f4ac02c18d7ed7bf02b6bdb1e548',
                    thumb: '/assets/thumb/b5a8f09516d393f8f75cdc811b019008.jpg',
                },
                {
                    videoId: '38b2d90d89c929b2bead6fbedb19b1ea',
                    thumb: '/assets/thumb/8d052115597846a44123bf1c6c1e8a4f.jpg',
                },
                {
                    videoId: '5e37d6063f8ea43177e6fa4394415b6c',
                    thumb: '/assets/thumb/536548e91868807b87b826191d8b20f4.jpg',
                },
                {
                    videoId: '621a4be6a08328097f72dcc90c29d9f8',
                    thumb: '/assets/thumb/8d4b96af9dd20f86f38a1b1ee154364c.jpg',
                },
                {
                    videoId: '63c1b98b98f9916c98a26c9f923ecb47',
                    thumb: '/assets/thumb/6f5480da0c5542c18abd99c69ffb6757.jpg',
                },
                {
                    videoId: 'aa61cb3b3dea2d05eea2bdc2757993f3',
                    thumb: '/assets/thumb/ca0ed3e805e65c13dd1f8bff17f62387.jpg',
                },
                {
                    videoId: 'b8e876afbd9dbc9894f36b37e943c44b',
                    thumb: '/assets/thumb/3f080ac507496e09b11c97e8017f477b.jpg',
                },
                {
                    videoId: '95d0de510fe55155b546d3e5d023fec0',
                    thumb: '/assets/thumb/c7d3db6502697c9fbe15640e9143012f.jpg',
                },
                {
                    videoId: 'd5683d841bb775e39d1b4d6c72e8156c',
                    thumb: '/assets/thumb/75e8b9753baf800d40c2089596fe22f6.jpg',
                },
                {
                    videoId: '9c019d5bf55f21c3ee0d8fec175222dd',
                    thumb: '/assets/thumb/97c4d0483b5b06a06b5d4dd3468ef089.jpg',
                },
                {
                    videoId: 'ba2495795a4cf6603ecaa4f130e75d4e',
                    thumb: '/assets/thumb/54ab137640846c7e2a1623ead3628c91.jpg',
                },
                {
                    videoId: 'bc45de45a947ee7e962b934fc955418b',
                    thumb: '/assets/thumb/ee4326c107446893044ae0e7d306f29f.jpg',
                },
            ]
        }
    },
    mounted() {
        // document.addEventListener()
        // window.onresize = () => {
        //     const newWidth = window.innerWidth;
        //     const newHeight = window.innerHeight;
        //     console.log(`Новый размер окна: ${newWidth}x${newHeight}`);
        // };
    },
    methods: {
        handleClickThumb: function(item,index) {
            this.videoId = item.videoId
            this.currentIndex = index
        },
        handleScrollThumb: function(event) {
            console.log('handleScrollThumb')
            
            // const scrollBox = document.getElementById('.rutube-carusel .__control ul');
            const scrollBox = document.querySelector('.rutube-carusel .__control ul')
            // let lastPosition = 0;

            // Обработка события прокрутки
            // scrollBox.addEventListener('wheel', function(e) {
            // e.preventDefault(); // Предотвращаем стандартную вертикальную прокрутку

            // Определяем смещение относительно предыдущей позиции
            const delta = event.deltaY * 0.5; // Коэффициент скорости прокрутки

            // Текущая позиция плюс новое смещение
            const newPosition = this.wheelLastPosition - delta;

            // Ограничиваем диапазон прокрутки, чтобы предотвратить выход за пределы содержимого
            const maxLeftOffset = -(scrollBox.scrollWidth - scrollBox.offsetWidth);
            const boundedPosition = Math.max(maxLeftOffset, Math.min(newPosition, 0));

            // Устанавливаем новую позицию
            scrollBox.scrollTo({
                left: boundedPosition * -1,
                behavior: 'smooth' // плавность перехода
            });
            // console.log('handleScrollThumb', newPosition, boundedPosition)
            // Запоминаем последнюю позицию
            this.wheelLastPosition = boundedPosition;
        },
    }
}
</script>
<style lang="scss">
.rutube-carusel{
    .__control{
        padding-top: 10px;
        padding-bottom: 10px;
        ul{
            list-style: none;
            margin: 0;
            padding: 4px;
            // padding-bottom: 10px;
            display: flex;
            flex-direction: row;
            overflow-x: scroll;
            // justify-content: center;
            li{
                max-width: 125px;
                min-width: 125px;
                button{
                    background: none;
                    border: none;
                    cursor: pointer;
                    transition: .3s;
                    border: solid 1px #ffffff25;
                    border-radius: 5px;
                    margin-right: 4px;
                    padding: 0;
                    overflow: hidden;
                    :last-child{
                        margin-right: 0;
                    }
                    // border-width: 5%;
                    &:hover{
                        transition: .3s;
                        transform: scale(1.05);
                    }
                    &.__active{
                        border: solid 1px #ffffff9e;
                        // border-width: 80%;
                    }
                }
                img{
                    width: 100%;
                    height: auto;
                    // border-radius: 5px;
                }
            }
        }
        /* Базовые настройки для всех элементов */
        ul{
            &::-webkit-scrollbar {
            // width: 10px; /* Ширина вертикального скролла */
            height: 6px; /* Высота горизонтального скролла */
            }
    
            /* Полоса прокрутки */
            &::-webkit-scrollbar-track {
            background: #f1f1f100; /* Цвет фона дорожки */
            border-radius: 3px; /* Скругление краев */
            }
    
            /* Ползунок (thumb) */
            &::-webkit-scrollbar-thumb {
            background: #888; /* Основной цвет ползунка */
            border-radius: 3px; /* Скругленные углы */
            }
    
            /* Изменение цвета ползунка при наведении */
            &::-webkit-scrollbar-thumb:hover {
            background: #555; /* Темнее при наведении */
            }
    
            /* Горизонтальная полоса прокрутки */
            &::-webkit-scrollbar-horizontal {
            height: 6px; /* Высоту можно уменьшить или увеличить */
            }
    
            /* Только вертикальная полоса прокрутки */
            // &::-webkit-scrollbar-vertical {
            // width: 10px; /* Ширину можно изменять */
            // }
        }
    }
}
</style>
